// API Configuration
// Usa la variabile d'ambiente se disponibile, altrimenti fallback intelligente
const API_BASE_URL = process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.semanticai.it'  // Backend Render.com
    : 'https://api.semanticai.it');

// API Key per protezione endpoints
const API_KEY = process.env.REACT_APP_API_KEY || 'DonatApp2025!';

// Helper per creare headers con API Key
const getApiHeaders = (additionalHeaders = {}) => ({
  'Content-Type': 'application/json',
  'x-api-key': API_KEY,
  ...additionalHeaders
});

export { API_BASE_URL, API_KEY, getApiHeaders };
